"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ = require("../"); // ARCHITECT-MIXINS [ MAKE > BOX ] #############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var _default = function _default(ORIENTATION) {
  switch (ORIENTATION) {
    case 'left':
      return "\n        display: flex;\n        align-items: center;\n        flex-direction: row-reverse;\n\n        figure {\n          margin-right: var(--gutter-medium);\n          width: 40%;\n        }\n\n        @media ".concat(_._mixin_device.s, " {\n          display: flex;\n          align-items: center;\n          flex-direction: column-reverse;\n\n          figure {\n            margin: 0;\n            width: 100%;\n          }\n        }\n\n      ");

    case 'right':
      return "\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n\n        figure {\n          margin-left: var(--gutter-medium);\n          width: 40%;\n        }\n\n        @media ".concat(_._mixin_device.s, " {\n          display: flex;\n          align-items: center;\n          flex-direction: column;\n\n          figure {\n            margin: 0;\n            width: 100%;\n          }\n        }\n\n      ");

    case 'top':
      return "\n        display: flex;\n        align-items: center;\n        flex-direction: column-reverse;\n\n        div {\n          width: 60%;\n          margin: var(--gutter) auto 0 auto;\n          text-align: center;\n        }\n\n        figure {\n          width: 60%;\n        }\n\n        @media ".concat(_._mixin_device.s, " {\n\n        }\n\n      ");

    case 'bottom':
      return "\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n\n        div {\n          width: 60%;\n          margin: 0 auto var(--gutter) auto;\n          text-align: center;\n        }\n        figure {\n          width: 60%;\n        }\n\n        @media ".concat(_._mixin_device.s, " {\n\n        }\n\n      ");

    default:
      return null;
  }
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports["default"] = _default;